import { ReactComponent as CheckOn } from "../../assets/icons/checkOn.svg";
import { ReactComponent as CheckOff } from "../../assets/icons/checkOff.svg";

type CheckBoxProps = {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    className?: string;
    label?: string;
    disabled?: boolean;
};

const CheckBox = ({ checked = false, onChange, className, label, disabled }: CheckBoxProps) => {
    const handleToggle = () => {
        if (disabled) return;

        if (onChange) {
            onChange(!checked);
        }
    };

    return (
        <div className={`flex items-center ${disabled ? "cursor-default" : "cursor-pointer"} ${className}`} onClick={handleToggle}>
            <div className="flex items-center justify-center w-6 h-6">{checked ? <CheckOn /> : <CheckOff />}</div>
            {label && <span className="ml-2 text-gray2">{label}</span>}
        </div>
    );
};

export default CheckBox;
